import dayjs from 'dayjs';
import { GroupSortingField } from '@/gql/enums';

export enum GroupColumnKey {
    Id = 'id',
    Name = 'name',
    Description = 'description',
    UpdatedAt = 'updatedAt',
    TotalMemberCount = 'totalMemberCount',
}

/**
 * Maps UI column keys to the backend sorting field names
 */
export const getSortField = (columnKey: GroupColumnKey): GroupSortingField | null => {
    switch (columnKey) {
        case GroupColumnKey.Name:
            return GroupSortingField.Name;
        case GroupColumnKey.Description:
            return GroupSortingField.Description;
        case GroupColumnKey.UpdatedAt:
            return GroupSortingField.UpdatedAt;
        case GroupColumnKey.TotalMemberCount:
            return GroupSortingField.MemberCount;
        default:
            return null;
    }
};

/**
 * Formats a single date for display in the table
 */
export const formatDate = (date: string | Date | null | undefined): string => {
    if (!date) {
        return '-';
    }
    return dayjs(date).format('DD/MM/YYYY');
};
